import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a1fafcb6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1fafcb6')) {
      api.createRecord('a1fafcb6', component.options)
    } else {
      api.reload('a1fafcb6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a1fafcb6", function () {
      api.rerender('a1fafcb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/sideBar/index.vue"
export default component.exports